"use strict";

define('service/assignment',['appkit/service', '../model/assignment', '../model/assignment.type', '../collection/assignments', '../collection/base'], function (Service, Assignment, AssignmentType, Assignments, BaseCollection) {
  var AssignmentService = Service.extend({
    getTypes: function getTypes() {
      if (!this.types) {
        this.types = AssignmentType.all();
        return this.types.fetch().promise();
      }
      return Promise.resolve(this.types);
    },
    getConflictOfInterest: function getConflictOfInterest(assignments) {
      var conflictTypes = AssignmentService.ConflictOfInterest,
        conflicts = new BaseCollection();
      for (var a = 0, numOfConflicts = conflictTypes.length; a < numOfConflicts; a++) {
        conflicts.add(assignments.getByAssignmentTypeDescription(conflictTypes[a]).models);
      }
      return conflicts.pluck('person');
    },
    newGroupAssignments: function newGroupAssignments(documentId, objs) {
      return this.setupAssignmentObjs(objs).tap(function (assignments) {
        return assignments.requestGroupAssignments(documentId);
      });
    },
    newPropertyAssignments: function newPropertyAssignments(documentId, objs) {
      return this.setupAssignmentObjs(objs).tap(function (assignments) {
        return assignments.requestPropertyAssignments(documentId);
      });
    },
    newPersonAssignments: function newPersonAssignments(documentId, objs) {
      return this.setupAssignmentObjs(objs).tap(function (assignments) {
        return assignments.requestPersonAssignments(documentId);
      });
    },
    setupAssignmentObjs: function setupAssignmentObjs(objs) {
      var assignments = new Assignments();
      return this.getTypes().bind(this).then(function () {
        for (var i = 0, len = objs.length; i < len; i++) {
          objs[i].assignmentType = this.mapAssignmentType(objs[i].type);
          delete objs[i].type;
          assignments.add(objs[i]);
        }
        return Promise.resolve(assignments);
      });
    },
    mapAssignmentType: function mapAssignmentType(desc) {
      return this.types.findWhere({
        description: desc
      });
    },
    validateReviewerAssignments: function validateReviewerAssignments(assignments, reviewers) {
      var reviewType = assignments.getByAssignmentTypeProp('IRB_REVIEW_TYPE', 'description').models[0].get('value'),
        isFullExpFlag = assignments.getByAssignmentTypeProp('IRB_IS_FULL_EXPEDITED', 'description').models[0],
        isFullExpedited = isFullExpFlag ? isFullExpFlag.get('value') : false,
        primaryReviewer = reviewers.primaryReviewer,
        fullExpReviewer = reviewers.fullExpReviewer,
        reviewers = reviewers.reviewers,
        reviewerErr = {
          field: 'primaryReviewer',
          error: 'Reviewer is required.'
        },
        fullExpReviewerErr = {
          field: 'fullExpReviewer',
          error: 'Reviewer is required.'
        },
        boardReviewerErr = {
          field: 'boardRoster',
          error: 'A primary reviewer or at least one reviewer is required.'
        },
        errors = [];
      switch (reviewType) {
        case 'FULL':
          if (isFullExpedited == 'true') {
            if (!fullExpReviewer) {
              errors.push(fullExpReviewerErr);
            }
          } else if (!reviewers.length && !primaryReviewer) {
            errors.push({});
          }
          break;
        case 'EXPEDITED':
        case 'LIMITED':
        case 'ADMINISTRATIVE':
          if (!reviewers.length && !primaryReviewer) {
            errors.push(boardReviewerErr);
          }
          break;
        case 'EXEMPT':
          if (!primaryReviewer) {
            errors.push(reviewerErr);
          }
          break;
      }
      return errors;
    }
  });
  AssignmentService.ConflictOfInterest = ['PRINCIPAL_INVESTIGATOR', 'CO_PRINCIPAL_INVESTIGATOR', 'PRIMARY_CONTACT', 'INVESTIGATOR'];
  AssignmentService.ReviewTypes = [{
    description: 'Full Board',
    value: 'FULL'
  }, {
    description: 'Expedited',
    value: 'EXPEDITED'
  }, {
    description: 'Exempt',
    value: 'EXEMPT'
  }, {
    description: 'Limited IRB',
    value: 'LIMITED'
  }, {
    description: 'Admin Level Review',
    value: 'ADMINISTRATIVE'
  }];
  AssignmentService.ReviewerTypes = [{
    description: 'Board Member',
    value: 'IRB_BOARD'
  }, {
    description: 'Analyst',
    value: 'IRB_ANALYST'
  }];
  return AssignmentService;
});

